import { DomainPreferences } from '../../../../api/types';
import { DashboardConfig } from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import { StoryboardDateUtils } from '../../utils';
import { getMixiHumanCapitalDbPageConfig } from './human-capital-db-page-configs';

const dashboardId = 'human-capital';

export const MixiHumanCapitalDashboardConfig: (domainPreferences: DomainPreferences) => DashboardConfig = (
  domainPreferences: DomainPreferences
) => {
  const storyboardDateUtils = new StoryboardDateUtils();
  return {
    id: dashboardId,
    title: {
      [Languages.EN]: 'Human Capital DB',
      [Languages.JA]: '全体サマリ',
    },
    enabled: true,
    pages: [
      getMixiHumanCapitalDbPageConfig(storyboardDateUtils, domainPreferences, {
        pageId: 1,
        dashboardId,
        title: {
          [Languages.EN]: 'Summary',
          [Languages.JA]: '全体サマリ',
        },
      }),
    ],
  };
};
